import API_BASE_URL from "../../../../../../Constants";

export const fetchAllDOBProfiles = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/inspections/dob-profiles`,
      {
        method: "GET",
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  } catch (err) {
    console.error("Error fetching director profiles:", err);
  }
};

export const fetchDOBProfile = async (directorId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/inspections/dob-profiles/${directorId}`,
      {
        method: "GET",
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  } catch (err) {
    console.error("Error fetching director profile:", err);
  }
};

export const upsertDOBProfile = async (profile) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/inspections/dob-profiles`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(profile),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  } catch (err) {
    console.error("Error creating director profile:", err);
  }
};

export const searchDOBProfileByEmail = async (lookupObject, headers) => {
  console.log("Owner Lookup Object:", lookupObject);
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/inspections/email-lookup`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(lookupObject),
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Owner Lookup Result:", data);
    return data;
  } catch (error) {
    console.error("Error fetching owner lookup:", error);
    throw error;
  }
};
